module.exports = __webpack_public_path__ + "static/media/4522.5ada02c2.jpg";